// extracted by mini-css-extract-plugin
export default {"wrapper":"Yo-z","response":"Zo-z","error":"_o-z","disabled":"ap-z","buttons":"bp-z","feedbackQuestionSection":"cp-z","yesNoWrapper":"dp-z"};